import React, {
  useContext,
  useEffect,
  useState
}                                 from 'react';
import { historyPropType }        from '~/config/routerPropTypes';
import AddonContext               from './context';
import ModalDelete                from '~/components/ModalDelete';
import { toast }                  from 'react-toastify';
import Paper                      from '~/components/Paper';
import card_membership            from '@material-ui/icons/CardMembership';
import PaperButtons               from '~/components/PaperButtons';
import Request                    from '~/providers/Request';
import GridContainer              from '~/components/GridContainer';
import GridItem                   from '~/components/GridItem';
import InputShow                  from '~/components/InputShow';
import InputControl               from '~/components/Input/InputControl';
import CardPreview                from '~/components/Card/CardShow';
import {
  createCards,
  editCards,
  cards
}                                 from '~/config/routes';
import { useTranslation }         from 'react-i18next';
import CardRecord                 from '~/records/CardRecord';
import { AbilityContext }         from '~/contexts/Can';

const attrName = (attr) => CardRecord.hummanAttributeName(attr);

function ShowAddon({history}) {
  const { t } = useTranslation();
  const [ record, setRecord] = useState(new CardRecord());
  const { records, addRecords } = useContext(AddonContext);
  const [loading, setLoading] = useState(true);
  const { id } = history.location.route.getParams();
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if(records && records[id]){
      setRecord( record.updateAttributes(records[id]) );
    }
    setLoading(true);
    Request.get(`/admin/promo_cards/${id}`, {})
    .then(response => {
      setLoading(false);
      addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
      setRecord( record.updateAttributes(response.data) );
    })
    .catch( e => {
      console.error(e);
      setLoading(false);
      });
    }, []);

    async function handleDelete(){
      setLoading(true);
      Request.del(`/admin/promo_cards/${id}`)
      .then(() => {
        toast.success(t('delete-toast-success'));
        history.push(cards.spec);
      })
      .catch(() => {
        setLoading(false);
        toast.error(t('delete-toast-fail'));
      });
      setModal(false);
  }
  if(record.get('image')){
    console.log(record.getImageUrl(), 'AAA');
  }
  return (
    <>
    <Paper
      Icon={card_membership}
      iconColor='blue'
      title={t('cards.defSingular')}
      loading={ loading }
      actions={
        <PaperButtons
        id={ id }
        setModal={ability.can('delete', 'Cards') ? setModal : null}
        backRoute={ cards }
        newRoute={ability.can('new', 'Cards') ? createCards : null}
        editRoute={ability.can('edit', 'Cards') ? editCards : null}
        />}
    >
          <GridContainer>
            <GridItem xs={8} md={12}>
              <GridContainer>
                <GridItem xs={8} md={8}>
                <InputShow
                  value={record.get('name')}
                  label={attrName('name')}
                />
                </GridItem>
                <GridItem xs={8} md={4}>
                  <InputShow
                    value={record.get('url')}
                    label={attrName('url')}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={8} sm={10} md={10}>
                  <InputShow
                    value={record.get('description')}
                    label={attrName('description')}
                    multiline={true}
                    InputProps={{
                      multiline:true,
                      rows:'3',
                    }}
                  />
                </GridItem>
                <GridItem xs={8} md={2}>
                  <InputShow
                    value={record.get('is_active')}
                    label={attrName('is_active')}
                    type='boolean'
                  />
                </GridItem>
              </GridContainer>
            </GridItem>
            <GridItem xs={12} md={12}>
              <InputControl
                value={record.get('image_id')}
                name="image_id"
                disabled={loading}
                label={t('Card')}
                inputComponent={CardPreview}
                InputProps={{
                  loading: loading,
                  cardType: record.get('type'),
                  background: record.get('bg_color'),
                  text_color: record.get('text_color'),
                  title_color: record.get('title_color'),
                  title: record.get('name'),
                  image: record.get('image_base64') ? `data:image/png;base64,${record.get('image_base64')}`: record.get('image') ? record.getImageUrl(): null,
                  description: record.get('description'),
                  url: record.get('url'),
                }}
                onChange={() => {}}
              />
            </GridItem>
          </GridContainer>
      </Paper>
      <ModalDelete
        modal={modal}
        onClose={() => {
          setModal(false);
        }}
        name={record.get('name')}
        id={record.get('id')}
        deleteAction={handleDelete}
      />
    </>
  );
}

ShowAddon.propTypes={
  history: historyPropType,
};

export default ShowAddon;
